import React, { useState, useEffect,useContext } from 'react'
import '../css/style.css';
import '../css/login1.css';
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import Select from "react-select";
import {subApi} from '../../services/user-api';
import { useTranslation } from "react-i18next";
import {serviceId,Loader,countryCode,flag,customStyles,serviceName} from "../../utils/constant";
import { LanguageContext } from "../../components/LanguageContext"

const Mng = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [flowLoading, setFlowLoading] = useState(false); 
    const [alreadySub, setAlreadySub] = useState(false);   
    const [flow, setFlow] = useState('');   
    const [phone, setPhone] = useState(localStorage.getItem("ugAlias"));
    const [subOption, setSubOption] = useState(1);
    const [plan, setPlan] = useState(1);
    const [price, setPrice] = useState(["0","50 cfa","175 cfa","500 cfa"]);
    const [planType, setPlanType] = useState(["0","Day","Week",'Month']);  
    const [message, setMessage] = useState({message: "",error: false});
    const [otpId, setOtpId] = useState('');
    const [otp, setOtp] = useState('');
    const [ButtonDisabled, setButtonDisabled] = useState(true); 
    const { t } = useTranslation("global"); 
    const languages = [{ value: "fr", label: "French" },{ value: "en", label: "English" }]
 

    useEffect(() => {
        console.log("phone="+phone);
        setMessage({message: "",error: false});        
        if (phone) {
            setFlowLoading(true); 
            subApi({action:0,ani: phone,serviceId:serviceId}).then((res) => {
                console.log(res);                 
                if(res.data.data!==null && res.data.data!==undefined)
                {                    
                    setFlowLoading(false);
                    if(res.data.responseCode == 205) setFlow("LOWBALANCE"); 
                    else{
                    localStorage.setItem("token", res.data.data.accessToken);
                    window.location.href ="/home";
                    }
                }
                else
                {
                    setFlowLoading(false);
                    setFlow("PACK");//
                }
            }).catch((err) => {
                console.log(err);
                setFlowLoading(false);
                setFlow("PACK");
            });
        }           
    }, []);   

    
    const handleNumberChange = async(event) =>{
        const input = event.target.value;
        if(input.length<11)setPhone(input);
        setButtonDisabled(input.length <8);
    }  
    const handleRadioChange = async(input) =>{
        setPlan(input);
    }  
    const handleSubChange = async(input) =>{
        setSubOption(input);
    }    
    const handleSubOptionClick = async() => {
        if(subOption==2){setPlan(3);}
        else {setPlan(1);}
        setFlow("PACK");
    }
    const cancel = async(input) => {
        setMessage({message: "",error: false});
        setFlow(input);
    }
    const handleNumInputsChange = (numInputs) => {
        setOtp(numInputs);
        setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
    }
    const redirectTo = async(input) => {
        if(input==="/home")window.location.href ="/home";
        else navigate(input);
      };
    const checkSubStatus = async() => {
        //console.log(phone);
        setMessage({message: "",error: false});  
        var nm=phone;if(nm.length<10)nm=countryCode+nm   
        setLoading(true);
        await subApi({action:0,serviceId:serviceId,ani:nm,mode:'WAP'}).then((res) => {            
            console.log(res)
            if(res.data.responseCode == 205) setFlow("LOWBALANCE");
            else{
                localStorage.setItem("token", res.data.data.accessToken);
                window.location.href ="/home";
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => setLoading(false))
      };

    const subscribe = async() => {
        //console.log(phone);
        setMessage({message: "",error: false});  
        var nm=phone;if(nm.length<10)nm=countryCode+nm   
        setLoading(true);
        await subApi({action:1,serviceId:serviceId,planId:plan,ani:nm,mode:'WAP'}).then((res) => {            
            console.log(res)
            if(res.data.responseCode == 205) setFlow("LOWBALANCE");
            else{
                localStorage.setItem("token", res.data.data.accessToken);
                setFlow("SUCCESS");
            }
        }).catch((err) => {
            console.log(err)
            setMessage({message: err.message,error: true})
        }).finally(() => setLoading(false))
      };           
    const sendOtp = async() => {
        console.log('phone='+phone);
        setMessage({message: "",error: false});
        if(phone && phone.length>=8)
        {
            var nm=phone;if(nm.length<10)nm=countryCode+nm
            setLoading(true);
           await subApi({action:3,serviceId:serviceId,ani: nm}).then((res) => { 
            //subApi({action:0,ani: nm,serviceId:serviceId}).then((res) => {     
                if(res.status===200)
                { 
                   /* localStorage.setItem("token", res.data.data.accessToken);
                    window.location.href ="/home";*/
                    /*if(res.data.responseCode===202) // already subscribed 
                    {
                        localStorage.setItem("token", res.data.data.accessToken);
                        window.location.href ="/home";
                        //setAlreadySub(true);setFlow("SUCCESS");
                    }
                    else  setFlow("PACK"); */
                    setFlow("OTPCONFIRM");
                }               
                else {setFlow("OTPCONFIRM");}
                setLoading(false);
            }).catch((err) => {
                console.log(err);
                //setFlow("PACK");
                setLoading(false);
            });
        }
        else if(phone && phone.length>0){setMessage({message: "Please enter a valid number",error: true})}
        else{setMessage({message: "Please enter a number",error: true})}
       
       // navigate('/profile');
      };
    
      const confirmOtp = async() => {
        setMessage({message: "",error: false});  
        if(otp!=null && otp.length===4)
        {
            var nm=phone;if(nm.length<=8)nm=countryCode+nm
            setLoading(true);
            await subApi({action:4,serviceId:serviceId,ani: nm,otpId:otpId,otp:otp}).then((res) => {                    
                if(res.status===200)
                {
                    if(res.data.responseCode == 205) setFlow("LOWBALANCE"); 
                    else if(res.data.responseCode===202) // already subscribed 
                    {
                        localStorage.setItem("token", res.data.data.accessToken);
                        //window.location.href ="/home";
                        setAlreadySub(true);setFlow("SUCCESS");
                    }
                    else
                    {
                        localStorage.setItem("ugAlias",nm);
                        setFlow("PACK");
                    }                    
                }                
                else {setMessage({message: res.data.message,error: true})}
            }).catch((err) => {
                setMessage({message: err.message, error: true});
            }).finally(() => setLoading(false))
        }
        else{setMessage({ message:"OTP is not valid",error: true });}
      }     

      // Language option //
      
      const { language, changeLanguage } = useContext(LanguageContext); 
      const handleChange = (selectedOption) => {
        changeLanguage(selectedOption.value)
      }      
      const selectedOption = languages.find((option) => option.value === language)

  

    return (  
        flowLoading? <Loader />
        :<>     
        <div className='home'>
            <div className="maine-div">
                <div className="container-fluid box-wrapper login">
                    <div className='pt-5'>
                        <div className="row align-items-center">
                            <div className="col-4"></div>
                            <div className="col-4">
                                <div className="logo d-flex">
                                    {/* <img src="/images/uv_games_logo.png" alt="UVGames" /> */}
                                </div>
                            </div>

                            <div className="col-4">
                                <div className="pt-2">
                                        <Select
                                            menuPlacement="top"
                                            value={selectedOption}
                                            options={languages}
                                            onChange={handleChange}
                                            styles={customStyles}
                                            placeholder="Select Language"
                                        />        
                                </div>
                            </div>  
                        </div>
                    </div>                       
                    <div className="login-header pb-4">
                        <div className="box-wrapper mx-auto text-center position-relative"> 
                           <span className="modal-level-title game-title">{t("portalText.mngDesc")}</span>
                        </div>
                    </div>
                    <div className="login-info">
                        <div className="login-thumbnail3">
                            <img src="/images/login_img_new.png" alt="UVGames" />
                        </div>

                        { flow==="PACK" ? (
                        <> 
                            <h3 className="header-title-green mb-3 mt-3 text-center">{t("portalText.Sub Plan")}</h3>                        
                            <div className="text-left radio radio-pl">
                                <label>
                                    <input type="radio" id="rd1" value="1" checked={plan === 1} onChange={() => handleRadioChange(1)} />
                                    50 cfa/{t("portalText.Day")}
                                </label><br/>
                                <label>
                                    <input type="radio" id="rd2" value="2" checked={plan === 2} onChange={() => handleRadioChange(2)} />
                                    175 cfa/{t("portalText.Week")}
                                </label>  <br/>
                                  <label>
                                    <input type="radio" id="rd2" value="3" checked={plan === 3} onChange={() => handleRadioChange(3)} />
                                    500 cfa/{t("portalText.Month")}
                                </label>                                  
                            </div>
                            <div className="text-center phone-info">
                                {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                                {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={()=>setFlow('CONFIRM')}>{t("portalText.Sub Button")}</button>}
                            </div>
                        </> 
                        ): flow === "OTPCONFIRM" ?(
                        <>
                             <h3 className="login-title mb-3 mt-3 text-center">{t("portalText.Enter OTP")}</h3>
                             <div className="phone-info">
                                <div className="otp_section">               
                                    <OtpInput
                                        value={otp}
                                        numInputs={4}
                                        renderInput={(props, index) => (
                                            <input   {...props}  type="tel" inputMode="numeric" />
                                        )}
                                        inputStyle="form-control form-otp"
                                        onChange={handleNumInputsChange}
                                    />
                                </div>
                                {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                                {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={confirmOtp} disabled={ButtonDisabled}>{t("portalText.Confirm")}</button>}
                                <div className="resend_otp"><a className="send_otp_link" onClick={() => {cancel('')}}> &lt;&lt;&nbsp;{t("portalText.Back")}</a></div>
                            </div>
                        </>
                         ):flow === "CONFIRM" ?(
                            <>
                                 <h3 className="login-title mb-3 mt-3 text-center">{t("portalText.doubleConfirm")} <span className="span-bold"> {price[plan]+"/"+t("portalText."+planType[plan])} </span></h3>
                                 <h3 className="login-title mb-3 mt-3 text-center">{t("portalText.doubleConfirm2")}</h3>
                                 {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                                 {loading ? <Loader />:<>
                                    <button className="btn btn-primary btn-pm-theme" type="button" onClick={subscribe} >{t("portalText.YES")}</button>
                                    <button className="btn btn-primary btn-pm-theme2" type="button" onClick={()=>setFlow('')}>{t("portalText.NO")}</button>
                                 </>
                                 }
                                
                            </>
                        ):flow === "SUCCESS" ?(
                        <>
                            {alreadySub?
                            <h3 className="login-title-green mb-3 mt-3 text-center">{t("portalText.AlreadySub")}</h3>
                            : <h3 className="login-title-green mb-3 mt-3 text-center">{t("portalText.SubSuccess")+" ("+price[plan]+"/"+t("portalText."+planType[plan])+")"}</h3>
                            }
                            <h3 className="login-title mb-3 mt-3 text-center">{t("portalText.Access Service")}</h3>
                            {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={() => {redirectTo('/home')}}>{t("portalText.Click Here")}</button>}                          
                        
                        </>  
                         ):flow === "LOWBALANCE" ?(
                        <>
                            <h3 className="login-title-red mb-3 mt-3 text-center">{t("portalText.LowBalance1")}</h3>
                            {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={checkSubStatus}>{t("portalText.Click Here")}</button>}                        
                        
                        </>                        
                        ): (
                            <>    
                                 <h3 className="login-title mb-3 mt-3 text-center">{t("portalText.Welcome")+serviceName}</h3>                                
                                <div className="phone-input">  
                                    <div className="has-validation input-group">
                                        <div className="dialing-code">
                                            <img src={"https://flagcdn.com/"+flag+".svg"} width="24" alt="Cameroon" />
                                            <span>+{countryCode}</span></div>
                                            <input                                    
                                            className="form-control form-mobile-no" 
                                            type="number" 
                                            inputMode="numeric" 
                                            value={phone?phone:''}
                                            onChange={handleNumberChange}
                                            placeholder={t("portalText.Enter Number")}
                                        />             
                                        </div>                              
                                    {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}                              
                                    {loading ? <Loader />:<button className="btn btn-primary btn-pm-custom" type="button" onClick={sendOtp} disabled={ButtonDisabled}>{t("portalText.Submit")}</button>}
                                </div>
                            </>
                        )}
                    </div>                    
                </div>
            </div>
        </div>
        </>
    )
}

export default Mng